<app-validation-header>
  <ng-template #centerContent>
    <div title>Validation History</div>
    <div sub-title>
      Change Request: <a [routerLink]="['/change-request/id', updateNoticeId]">{{ updateNotice?.name }}</a>
    </div>
  </ng-template>
</app-validation-header>

<mat-card class="validation-history-container mat-elevation-z0">
  <mat-card-content>
    <div class="search-section space-16">
      <mat-form-field class="validation-history-search">
        <mat-label>Search Validation History</mat-label>
        <input
          [formControl]="searchControl"
          matInput />
        <button
          mat-icon-button
          matSuffix>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="validation-history-table">
      <app-validation-history-table
        #validationHistoryTable
        [validationHistory]="validationHistory"
        [columnsConfig]="columns"
        [paginator]="paginator"
        [searchTerm]="searchTerm"
        [customCellTpl]="{ result: resultTpl, dataset: datasetTpl, schema: schemaTpl, bizrule: bizruleTpl }">
        <ng-template
          #resultTpl
          let-row
          let-column="column">
          <div
            class="badge"
            [class]="column.cell(row)?.toLowerCase()">
            <mat-icon [color]="badgeIconLookup[column.cell(row)?.toLowerCase()].color">
              <span class="material-symbols-outlined">{{ badgeIconLookup[column.cell(row)?.toLowerCase()].icon }}</span>
            </mat-icon>
            <span>{{ column.cell(row) }}</span>
          </div>
        </ng-template>
        <ng-template
          #datasetTpl
          let-row
          let-column="column">
          <div
            class="ellipsis"
            [matTooltip]="column.cell(row)">
            <a
              [routerLink]="['/update-notice', updateNoticeId, 'validation-report', row.name]"
              class="dataset-label">
              {{ column.cell(row) }}
            </a>
          </div>
        </ng-template>
        <ng-template
          #schemaTpl
          let-row
          let-column="column">
          <span class="schema-label"> {{ column.cell(row) }} </span>
        </ng-template>
        <ng-template
          #bizruleTpl
          let-row
          let-column="column">
          <div
            class="ellipsis"
            [matTooltip]="column.cell(row)">
            <span class="bizrule-label">{{ column.cell(row) }}</span>
          </div>
        </ng-template>
      </app-validation-history-table>
      @if (!validationHistory?.length || !validationHistoryTable.dataSource()?.filteredData?.length) {
      <div class="no-data-wrapper">
        <mat-icon>info</mat-icon>
        <span>
          {{ loaders?.validationHistory ? "Loading Validation History" : "No Validation History Data" }}
        </span>
      </div>
      }
    </div>
    <mat-divider></mat-divider>
    <div class="paginator-section">
      <mat-paginator
        #paginator="matPaginator"
        [length]="validationHistory?.length"
        [pageSize]="25"
        [pageSizeOptions]="[25, 50, 100]"
        aria-label="Select page">
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
